import { render, staticRenderFns } from "./ConfigSchedule.vue?vue&type=template&id=975c5958&scoped=true"
import script from "./ConfigSchedule.vue?vue&type=script&lang=js"
export * from "./ConfigSchedule.vue?vue&type=script&lang=js"
import style0 from "./ConfigSchedule.vue?vue&type=style&index=0&id=975c5958&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "975c5958",
  null
  
)

export default component.exports